import React from 'react';
import { Navbar, Nav, Container, Offcanvas, Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { appConfig } from '../../config/app';
import BrandLogo from '../shared/BrandLogo';

const HeaderLoggedOutMobile = () => {
    const history = useHistory();

    const handleFaqClick = () => {
        const faqElement = document.getElementById('faq');
        if (faqElement) {
            faqElement.scrollIntoView({ behavior: 'smooth' });
        } else {
            // Navigate to homepage and scroll to FAQ after navigation
            history.push('/');
            setTimeout(() => {
                const faqElement = document.getElementById('faq');
                if (faqElement) {
                    faqElement.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    };

    return (
        <div className="d-block d-lg-none mb-3">
            <Navbar fixed="top" collapseOnSelect expand="md" variant="dark" className="navbar-glass">
                <Container fluid>
                    <Navbar.Brand>
                        <BrandLogo />
                    </Navbar.Brand>
                    
                    <Navbar.Toggle aria-controls="offcanvasNavbar-expand-md" />
                    <Navbar.Offcanvas
                        id="offcanvasNavbar-expand-md"
                        aria-labelledby="offcanvasNavbarLabel-expand-md"
                        placement="end"
                        className="navbar-glass"
                    >
                        <Offcanvas.Header closeButton className="border-0">
                                                    <Offcanvas.Title id="offcanvasNavbarLabel-expand-md" className="text-white">
                            <BrandLogo showLink={false} maxHeight="1.25rem" />
                        </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1 pe-3">
                                <Nav.Link onClick={handleFaqClick} className="mb-3 text-white" style={{ cursor: 'pointer', fontSize: '1.1rem' }}>FAQ</Nav.Link>
                                
                                {/* Discord Logo */}
                                <div className="mb-4">
                                    <a 
                                        href={appConfig.social.discord}
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={{ fontSize: '2rem', color: '#5865f2' }}
                                    >
                                        <i className="fab fa-discord"></i>
                                    </a>
                                </div>
                                
                                {/* Login Link */}
                                <Link to="/login" className="d-block mb-3 text-center">
                                    <button className="btn btn-outline-light w-100">
                                        Login
                                    </button>
                                </Link>
                                
                                {/* Primary CTA */}
                                <Link to="/onboarding/platform" className="d-block">
                                    <Button 
                                        className="btn-primary-gradient btn-lg w-100"
                                        style={{
                                            fontSize: "1rem", 
                                            fontWeight: "600",
                                            padding: "12px 24px",
                                            height: "44px"
                                        }}
                                    >
                                        Get Started
                                    </Button>
                                </Link>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </div>
    );
};

export default HeaderLoggedOutMobile;